<template>
    <div :style="`background-image: url(${images.background})`" class="background" />
</template>

<script>
import BackgroundImage from '@/assets/images/login_background.svg'

export default {
    name: 'ImgBackground',
    data() {
        return {
            images: {
                background: BackgroundImage,
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.background {
    width: 100%;
    height: 100vh;
    background-repeat: no-repeat;
    background-position: 78% 32%;
}
</style>
